import { render, staticRenderFns } from "./UserApplicationLayout.vue?vue&type=template&id=f6ff2f6a&scoped=true"
import script from "./UserApplicationLayout.vue?vue&type=script&lang=js"
export * from "./UserApplicationLayout.vue?vue&type=script&lang=js"
import style0 from "./UserApplicationLayout.vue?vue&type=style&index=0&id=f6ff2f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff2f6a",
  null
  
)

export default component.exports